const routes = {
  home: '/',
  admin: '/admin',
};

export { routes };
